module.exports = __webpack_public_path__ + "static/media/clockedOn.bf2493f1.svg";